import { render, staticRenderFns } from "./home-new.vue?vue&type=template&id=72ef81f8&scoped=true"
import script from "./home-new.vue?vue&type=script&lang=js"
export * from "./home-new.vue?vue&type=script&lang=js"
import style0 from "./home-new.vue?vue&type=style&index=0&id=72ef81f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ef81f8",
  null
  
)

export default component.exports